import React from 'react';
import moment from 'moment';
import Config from '@skin_config';

export const RESULT_PAGE_ITEM_COUNT = 16;
export const OTHER_ROWS = 3;

export const ROW_HEIGHT = 57;

export const transactionTabel = (t) => [
  {
    name: 'Transaction Id',
    columnClassName: 'transaction-id',
    rowClassName: 'transaction-id',
    row: (item) => item.TransactionId,
  },
  {
    name: 'Date',
    row: (item) => moment.unix(item.Created).format(Config.main.dateTimeFormat),
  },
  {
    name: 'Game',
    row: (item) => item.Game,
  },
  {
    name: 'Amount',
    row: (item) => <span className={item.Amount > 0 ? 'positive' : 'negative'}>{item.Amount}</span>,
  },
  {
    name: 'Finale Balance',
    row: (item) => item.Balance,
  },

];
